import { useState } from 'react';
import { Network, Map, Eye, Table, Activity, FileImage, TrendingUp, GitCompare, Loader, Download } from 'lucide-react';

export default function Trame() {
  const [activeTab, setActiveTab] = useState('cartographie');
  const [loading, setLoading] = useState(false);

  const tabs = [
    { id: 'cartographie', label: 'Cartographie Interactive', icon: Map },
    { id: 'tableau', label: 'Tableau Dynamique', icon: Table },
    { id: 'heatmap', label: 'Heatmap', icon: Activity },
    { id: 'flux', label: 'Flux de Progression', icon: TrendingUp },
    { id: 'analytique', label: 'Analytique', icon: Eye },
    { id: 'comparatif', label: 'Mode Comparatif', icon: GitCompare }
  ];

  // Mock data
  const mockData = {
    competences: [
      { id: 1, label: 'JavaScript', niveau: 3, secteur: 'Informatique', transversal: true },
      { id: 2, label: 'React', niveau: 4, secteur: 'Informatique', transversal: false },
      { id: 3, label: 'Communication', niveau: 2, secteur: 'Transversal', transversal: true },
      { id: 4, label: 'Gestion de projet', niveau: 3, secteur: 'Management', transversal: true }
    ],
    stats: {
      tauxCouverture: 78,
      competencesPartagees: 156,
      niveauxMoyens: 3.2,
      certifications: 234
    }
  };

  const handleExportGraphique = (format) => {
    alert(`Export ${format.toUpperCase()} lancé !`);
  };

  const renderContent = () => {
    if (loading) {
      return (
        <div className="flex items-center justify-center py-12">
          <Loader className="w-8 h-8 animate-spin text-purple-600" />
        </div>
      );
    }

    switch (activeTab) {
      case 'cartographie':
        return (
          <div className="space-y-6">
            <div className="bg-white rounded-xl p-6 border border-gray-200">
              <h3 className="font-semibold text-gray-900 mb-4 flex items-center gap-2">
                <Map className="w-5 h-5 text-purple-600" />
                Cartographie interactive des compétences
              </h3>
              <div className="h-[500px] bg-gradient-to-br from-purple-50 to-pink-50 rounded-lg flex items-center justify-center border-2 border-dashed border-purple-300">
                <div className="text-center">
                  <Network className="w-24 h-24 text-purple-400 mx-auto mb-4" />
                  <p className="text-gray-700 font-medium text-lg">Visualisation en graphe</p>
                  <p className="text-sm text-gray-500 mt-2">
                    Graphes, bulles et clusters de compétences
                  </p>
                  <div className="mt-6 flex gap-3 justify-center">
                    <div className="px-4 py-2 bg-white rounded-lg shadow-sm border border-gray-200">
                      <div className="text-2xl font-bold text-purple-600">234</div>
                      <div className="text-xs text-gray-600">Nœuds</div>
                    </div>
                    <div className="px-4 py-2 bg-white rounded-lg shadow-sm border border-gray-200">
                      <div className="text-2xl font-bold text-pink-600">467</div>
                      <div className="text-xs text-gray-600">Connexions</div>
                    </div>
                    <div className="px-4 py-2 bg-white rounded-lg shadow-sm border border-gray-200">
                      <div className="text-2xl font-bold text-indigo-600">12</div>
                      <div className="text-xs text-gray-600">Clusters</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-4 flex gap-2">
                <button
                  onClick={() => handleExportGraphique('png')}
                  className="flex items-center gap-2 px-4 py-2 bg-purple-500 text-white rounded-lg hover:bg-purple-600 transition-colors"
                >
                  <FileImage className="w-4 h-4" />
                  Export PNG
                </button>
                <button
                  onClick={() => handleExportGraphique('svg')}
                  className="flex items-center gap-2 px-4 py-2 bg-pink-500 text-white rounded-lg hover:bg-pink-600 transition-colors"
                >
                  <FileImage className="w-4 h-4" />
                  Export SVG
                </button>
                <button
                  onClick={() => handleExportGraphique('pdf')}
                  className="flex items-center gap-2 px-4 py-2 bg-indigo-500 text-white rounded-lg hover:bg-indigo-600 transition-colors"
                >
                  <Download className="w-4 h-4" />
                  Export PDF
                </button>
              </div>
            </div>
          </div>
        );

      case 'tableau':
        return (
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <h3 className="font-semibold text-gray-900 flex items-center gap-2">
                <Table className="w-5 h-5 text-purple-600" />
                Tableau dynamique des compétences
              </h3>
              <input
                type="text"
                placeholder="Rechercher..."
                className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
              />
            </div>

            <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
              <table className="w-full">
                <thead className="bg-gradient-to-r from-purple-50 to-pink-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                      Compétence
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                      Niveau
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                      Secteur
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                      Transversal
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {mockData.competences.map((comp) => (
                    <tr key={comp.id} className="hover:bg-gray-50">
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                        {comp.label}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                        <div className="flex items-center gap-2">
                          <div className="w-20 bg-gray-200 rounded-full h-2">
                            <div
                              className="bg-purple-500 h-2 rounded-full"
                              style={{ width: `${(comp.niveau / 5) * 100}%` }}
                            />
                          </div>
                          <span>{comp.niveau}/5</span>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                        {comp.secteur}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        {comp.transversal ? (
                          <span className="px-2 py-1 bg-green-100 text-green-700 text-xs rounded-full">
                            Oui
                          </span>
                        ) : (
                          <span className="px-2 py-1 bg-gray-100 text-gray-700 text-xs rounded-full">
                            Non
                          </span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        );

      case 'heatmap':
        return (
          <div className="space-y-6">
            <div className="bg-white rounded-xl p-6 border border-gray-200">
              <h3 className="font-semibold text-gray-900 mb-4 flex items-center gap-2">
                <Activity className="w-5 h-5 text-purple-600" />
                Heatmap de recouvrement
              </h3>
              <div className="h-96 bg-gradient-to-br from-orange-50 to-red-50 rounded-lg flex items-center justify-center border-2 border-dashed border-orange-300">
                <div className="text-center">
                  <Activity className="w-20 h-20 text-orange-400 mx-auto mb-3" />
                  <p className="text-gray-700 font-medium">Matrice de recoupements</p>
                  <p className="text-sm text-gray-500 mt-1">
                    Visualisation des intersections entre référentiels
                  </p>
                </div>
              </div>
            </div>
          </div>
        );

      case 'flux':
        return (
          <div className="space-y-6">
            <div className="bg-white rounded-xl p-6 border border-gray-200">
              <h3 className="font-semibold text-gray-900 mb-4 flex items-center gap-2">
                <TrendingUp className="w-5 h-5 text-purple-600" />
                Flux de progression
              </h3>
              <div className="h-96 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-lg flex items-center justify-center border-2 border-dashed border-blue-300">
                <div className="text-center">
                  <TrendingUp className="w-20 h-20 text-blue-400 mx-auto mb-3" />
                  <p className="text-gray-700 font-medium">Parcours de progression</p>
                  <p className="text-sm text-gray-500 mt-1">
                    Liens hiérarchiques entre niveaux, certifications et métiers
                  </p>
                </div>
              </div>
            </div>
          </div>
        );

      case 'analytique':
        return (
          <div className="space-y-6">
            <h3 className="font-semibold text-gray-900 flex items-center gap-2">
              <Eye className="w-5 h-5 text-purple-600" />
              Analytique avancée
            </h3>

            <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-xl p-6 border border-purple-200">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-12 h-12 bg-purple-500 rounded-lg flex items-center justify-center">
                    <TrendingUp className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <div className="text-3xl font-bold text-purple-900">
                      {mockData.stats.tauxCouverture}%
                    </div>
                    <div className="text-sm text-purple-700">Taux de couverture</div>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-pink-50 to-pink-100 rounded-xl p-6 border border-pink-200">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-12 h-12 bg-pink-500 rounded-lg flex items-center justify-center">
                    <Network className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <div className="text-3xl font-bold text-pink-900">
                      {mockData.stats.competencesPartagees}
                    </div>
                    <div className="text-sm text-pink-700">Compétences partagées</div>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-indigo-50 to-indigo-100 rounded-xl p-6 border border-indigo-200">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-12 h-12 bg-indigo-500 rounded-lg flex items-center justify-center">
                    <Activity className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <div className="text-3xl font-bold text-indigo-900">
                      {mockData.stats.niveauxMoyens}
                    </div>
                    <div className="text-sm text-indigo-700">Niveau moyen</div>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-6 border border-blue-200">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-12 h-12 bg-blue-500 rounded-lg flex items-center justify-center">
                    <Eye className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <div className="text-3xl font-bold text-blue-900">
                      {mockData.stats.certifications}
                    </div>
                    <div className="text-sm text-blue-700">Certifications</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl p-6 border border-gray-200">
              <h4 className="font-semibold text-gray-900 mb-4">Répartition par secteur</h4>
              <div className="space-y-3">
                {['Informatique', 'Commerce', 'Santé', 'Management'].map((secteur, i) => {
                  const percentage = [45, 25, 18, 12][i];
                  return (
                    <div key={secteur}>
                      <div className="flex items-center justify-between mb-1">
                        <span className="text-sm text-gray-700">{secteur}</span>
                        <span className="text-sm font-medium text-gray-900">{percentage}%</span>
                      </div>
                      <div className="w-full bg-gray-200 rounded-full h-2">
                        <div
                          className="bg-gradient-to-r from-purple-500 to-pink-600 h-2 rounded-full"
                          style={{ width: `${percentage}%` }}
                        />
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        );

      case 'comparatif':
        return (
          <div className="space-y-6">
            <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl p-6 border border-green-200">
              <h3 className="font-semibold text-gray-900 mb-4 flex items-center gap-2">
                <GitCompare className="w-5 h-5 text-green-600" />
                Mode comparatif
              </h3>
              <p className="text-sm text-gray-600 mb-6">
                Comparez plusieurs parcours, formations ou métiers côte à côte
              </p>

              <div className="grid grid-cols-2 gap-6">
                <div className="bg-white rounded-lg p-4 border-2 border-purple-300">
                  <h4 className="font-semibold text-gray-900 mb-3">Parcours A</h4>
                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between">
                      <span className="text-gray-600">Compétences</span>
                      <span className="font-medium">34</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Niveau moyen</span>
                      <span className="font-medium">3.5/5</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Transversal</span>
                      <span className="font-medium">45%</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Durée</span>
                      <span className="font-medium">6 mois</span>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-lg p-4 border-2 border-pink-300">
                  <h4 className="font-semibold text-gray-900 mb-3">Parcours B</h4>
                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between">
                      <span className="text-gray-600">Compétences</span>
                      <span className="font-medium">28</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Niveau moyen</span>
                      <span className="font-medium">3.2/5</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Transversal</span>
                      <span className="font-medium">38%</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Durée</span>
                      <span className="font-medium">4 mois</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-6 p-4 bg-white rounded-lg border border-gray-200">
                <h5 className="font-medium text-gray-900 mb-2">Compétences communes</h5>
                <div className="flex flex-wrap gap-2">
                  {['JavaScript', 'React', 'Communication', 'Gestion de projet'].map((comp) => (
                    <span key={comp} className="px-3 py-1 bg-purple-100 text-purple-700 text-sm rounded-full">
                      {comp}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-purple-500 to-pink-600 flex items-center justify-center text-white shadow-lg">
              <Network className="w-6 h-6" />
            </div>
            <div>
              <h1 className="text-3xl font-heading font-bold text-gray-900">Trame</h1>
              <p className="text-gray-600">Datavisualisation - Représentation visuelle avancée</p>
            </div>
          </div>
        </div>

        {/* Tabs */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-2 mb-6">
          <div className="flex flex-wrap gap-2">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`flex items-center gap-2 px-4 py-2.5 rounded-lg font-medium transition-all ${
                    activeTab === tab.id
                      ? 'bg-gradient-to-r from-purple-500 to-pink-600 text-white shadow-md'
                      : 'text-gray-600 hover:bg-gray-100'
                  }`}
                >
                  <Icon className="w-4 h-4" />
                  <span className="hidden sm:inline">{tab.label}</span>
                </button>
              );
            })}
          </div>
        </div>

        {/* Content */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
          {renderContent()}
        </div>
      </div>
    </div>
  );
}
